import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row, ListGroup, InputGroup } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import CreateBanner from './CreateBanner';
import { useDeletesizeMutation, useSizelistMutation } from '../../Redux/SizeSlice';
import { getQueryString } from "../../lib/Validationtext";
import moment from "moment";
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'
import { useSpecificationDeleteMutation } from '../../Redux/specification/specificationApi';
import { useBannerDeleteMutation, useGetBannerQuery } from '../../Redux/banner/bannerApi';


const BannerSection = ({ sliderID }) => {
  document.title = "Banner Slider";
  const [bannerDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] = useBannerDeleteMutation()
  const [bannerData, setBannerData] = useState(false);
  const [open, setOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(0);
  const [limit, setlimit] = useState(10);
  const { data: listData, isLoading: listLoading, refetch } = useGetBannerQuery(`?name=${sliderID}`);

  useEffect(() => {
    if (DeleteSuccess) {
      setShowModal(false)
      const message = deleteData?.message || "Delete successfully";
      toast.success(message);
      refetch()
      setBannerData({})
    }
  }, [deleteData, DeleteSuccess, deleteErr, listLoading]);

  const columns = useMemo(() => {
    let dynamicColumns = [
      {
        Header: "Image",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => {
          console.log(cellProps, "cellProps");
          return (

            <div className="flex-shrink-0 me-2">
              <div className="avatar-sm bg-light rounded p-1">
                <img
                  src={cellProps?.sliderImage}
                  alt=""
                  className="img-fluid d-block avatar-xs"
                />
              </div>
            </div>
          )
        },
      },
      {
        Header: "Create Date",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) =>
          cellProps.createdAt ? moment(cellProps.createdAt).format("DD-MM-YYYY") : "-",
      },
      {
        Header: "Edit Date",
        accessor: "updatedAt",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) =>
          cellProps.updatedAt ? moment(cellProps.updatedAt).format("DD-MM-YYYY") : "-",
      },
      {
        Header: "Action",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <ul className="hstack gap-2 list-unstyled mb-0">
            <li>
              <Button
                className="badge bg-primary-subtle text-primary edit-item-btn me-2"
                data-bs-toggle="modal"
                onClick={() => {
                  setOpen(!open);
                  setBannerData(cellProps);
                }}
              >
                Edit
              </Button>
            </li>
            <li>
              <Button
                data-bs-toggle="modal"
                className="badge bg-danger-subtle text-danger remove-item-btn"
                onClick={() => {
                  setBannerData(cellProps);
                  setShowModal(!showModal);
                }}
              >
                Delete
              </Button>
            </li>
          </ul>
        ),
      },
    ];

    if (sliderID !== "bannerSection") {
      // Include Category and Products columns
      dynamicColumns.unshift(
        {
          Header: "Category",
          disableFilters: true,
          filterable: true,
          accessor: (cellProps) => (
            <h5 className="mb-0 fs-16">{cellProps?.Category?.name}</h5>
          ),
        },
        {
          Header: "Products",
          disableFilters: true,
          filterable: true,
          accessor: (cellProps) => (
            <h5 className="mb-0 fs-16">{cellProps?.Product?.productTitle}</h5>
          ),
        }
      );
    } else {
      dynamicColumns.unshift({
        Header: "Coupon Name",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <h5 className="mb-0 fs-16">{cellProps?.
            Coupon?.name}</h5>
        ),
      }, {
        Header: "Coupon Code",
        disableFilters: true,
        filterable: true,
        accessor: (cellProps) => (
          <h5 className="mb-0 fs-16">{cellProps?.
            Coupon?.code}</h5>
        ),
      });
    }

    return dynamicColumns;
  }, [sliderID]);

  const [rows, setRows] = useState([
    { id: 1, name: 'Row 1', value: 'Value 1' },
    { id: 2, name: 'Row 2', value: 'Value 2' },
    { id: 3, name: 'Row 3', value: 'Value 3' },
  ]);

  const duplicateRow = (index) => {
    const newRow = { ...rows[index], id: rows.length + 1 };
    setRows([...rows, newRow]);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb title={`${sliderID} list`} pageTitle="More" />
          <div id="couponsList">
            <Row>
              <Col xxl={12}>
                <Card>
                  <Card.Body>
                    <Row className="align-items-center">
                      <Col xxl={3} md={5}>
                        <div className="search-box mb-3 mb-md-0">
                          <input type="text" className="form-control search" id="searchProductList"
                            placeholder="Search by banner name..." />
                          <i className="ri-search-line search-icon"></i>
                        </div>
                      </Col>
                      <Col className="col-md-auto ms-auto">
                        <Button variant='success' onClick={() => {
                          setOpen(!open)
                          setBannerData({})
                        }} className="add-btn"><i className="bi bi-plus-circle me-1 align-middle"></i>Add Banner</Button>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col lg={12}>
                <Card>
                  <Card.Body className='p-0'>
                    <TableContainer
                      columns={(columns || [])}
                      data={(listData?.response?.rows || [])}
                      iscustomPageSize={false}
                      isBordered={false}
                      customPageSize={5}
                      className="custom-header-css table align-middle table-nowrap"
                      tableClass="table-centered align-middle table-nowrap mb-0"
                      theadClass="text-muted table-light"
                      SearchPlaceholder='Search Products...'
                    />
                    <div className="noresult" style={{ display: "none" }}>
                      <div className="text-center">
                        <h5 className="mt-2">Sorry! No Result Found</h5>
                        <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                      </div>
                    </div>

                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </div>
          {open && <CreateBanner setBannerData={setBannerData} open={open} setOpen={setOpen} BannerData={bannerData} sliderID={sliderID} />}
          {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} handleSubmit={() => bannerDeleteFunc(bannerData?.id)} data={bannerData} />}
        </Container>
      </div>

      {/* <div>
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Value</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={row.id}>
                <td>{row.id}</td>
                <td>{row.name}</td>
                <td>{row.value}</td>
                <td>
                  <button onClick={() => duplicateRow(index)}>Duplicate</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </React.Fragment>
  );

};

export default BannerSection;
